import { make } from 'vuex-pathify';
import { DashboardMockDataService } from '../services/dashboard-mock-data.service.js';

const service = new DashboardMockDataService();

const state = {
  mockData: []
};

const mutations = make.mutations(state);

const actions = {
  fetchData({ commit }) {
    const { data } = service.fetchData();
    console.log(data);
    commit('SET_MOCK_DATA', data);
  }
};

export default {
  state,
  mutations,
  actions
};